
import React, { useEffect } from 'react';
import { Card, Form, Typography, Button, message } from 'antd';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';
import HotelProfileForm, { HotelProfileFormValues } from './HotelProfileForm';
import { useDispatch, useSelector } from 'react-redux';
import { createHotelProfileRequest, getHotelListProcessClear } from '@/AppRedux/actions/admin/hotelList';
import { RootState } from '@/AppRedux/reducers';

const { Title, Text } = Typography;

const CreateHotelProfile: React.FC = () => {
  const intl = useIntl();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, process } = useSelector((state: RootState) => state.hotelList);

  useEffect(() => {
    if (process.action === "CREATE_HOTEL_PROFILE_REQUEST" && process.message) {
      if (process.status) {
        message.success(process.message);
        dispatch(getHotelListProcessClear());
        navigate(-1);
      } else {
        message.error(process.message);
        dispatch(getHotelListProcessClear());
      }
    }
  }, [dispatch, navigate, process]);

  const onFinish = async (values: HotelProfileFormValues) => {
    dispatch(
      createHotelProfileRequest({
        code: values.code?.trim(),
        name: values.name?.trim(),
        active: true,
      }),
    );
  };

  const onBack = () => {
    navigate(-1);
  };

  return (
    <div style={{ maxWidth: 1000, margin: '0 auto' }}>
      <Card style={{ borderRadius: 8, boxShadow: '0 1px 2px 0 rgba(0,0,0,0.03)' }}>
        <div style={{ marginBottom: 32 }}>
          <Button
            type="text"
            icon={<ArrowLeftOutlined />}
            onClick={onBack}
            style={{ marginBottom: 16 }}
          >
            {intl.formatMessage({ id: 'admin.hotel_profile.back_to_list', defaultMessage: 'Back to Hotel List' })}
          </Button>
          <Title level={4} style={{ margin: 0 }}>
            {intl.formatMessage({ id: 'admin.hotel_profile.create.title', defaultMessage: 'Create Hotel Profile' })}
          </Title>
          <Text type="secondary">
            {intl.formatMessage({ id: 'admin.hotel_profile.create.description', defaultMessage: 'Add a new hotel' })}
          </Text>
        </div>

        <HotelProfileForm
          form={form}
          onFinish={onFinish}
          initialValues={{}}
          submitLoading={loading && process.action === "CREATE_HOTEL_PROFILE_REQUEST"}
        />
      </Card>
    </div>
  );
};

export default CreateHotelProfile;
